import React, { useContext, useEffect, useState } from 'react'
import UseHandleUrlRoute from '../handle-url-route/UseHandleUrlRoute';
import { PageConfigurationContext } from '../context/PageConfigurationContext';
import { OCLandInsightsContext } from '../context/OcLandInsightsContext';
import UseOath from '../../oauth/hook/UseOath';
import MapView from '@arcgis/core/views/MapView';
import LoadWidgetOnMount from '../../pages/map/LoadWidgetOnMount';
import { AddGraphicsFromURL } from '../../widgets/custom/assessor-add-graphic-from-url/AddGraphicFromUrlVM';
import { webmap } from '../../maps/webMap/WebMap';
import addBaseTemplateLayers from '../../views/mapView/addBaseTemplateLayers';
import { handleLoadedLayers } from '../../customParameterLayers';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import { selectLayerWatchLength } from '../../observers/layerObservers/selectLayerObserver';
import { selectionDataContext } from '../context/SelectionDataContext';
import usage_Tracking from '../../usageTracker';
import { addImagerytoView } from '../../widgets/custom/doc-overlay/DocOverlayVM';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import UseMsalLogin from '../../oauth/msal/UseMsalLogin';

const UseMapPageLoad = (mapDiv) => {
  const [view, setView] = useState<null|MapView>(null)
  const[viewReady,setViewReady]=useState<any>(false)
  const selectionDataCtx: any = useContext(selectionDataContext);
    const pageConfigurationCtx: any = useContext(PageConfigurationContext);
    const ocLandInsightsDictionaryCtx: any = useContext(OCLandInsightsContext);


    
  const isDevelopment =  process.env?.REACT_APP_IS_DEV==='true';

    UseHandleUrlRoute();
    
    const [portal, oauthChecked] = UseOath({
        esriOauthAppId: pageConfigurationCtx.data?.esriOauthAppId,
        mapId: pageConfigurationCtx.data?.mapId,
        portalURL: pageConfigurationCtx.data?.portalURL,
        mapPublic: pageConfigurationCtx.data?.mapPublic,
        apiKey: pageConfigurationCtx.data?.orgApikey
          ? pageConfigurationCtx.data.orgApikey
          : "",
        useMsalLogin:pageConfigurationCtx.data?.useMsalLogin
                    ? pageConfigurationCtx.data.useMsalLogin
                    : false,
    
      });

    
      useEffect(() => {
        const initView=async()=>{
          if (oauthChecked && mapDiv.current && pageConfigurationCtx.data?.mapId) {
            /**
             * Initialize application
             */
            let v = new MapView({
              container: mapDiv.current,
              map: webmap(pageConfigurationCtx.data?.mapId) as any,
            })
      
            await v.when()
             const map= await v.map
             //This checks for a base template to grab layers, tables, and search objects
             await addBaseTemplateLayers({baseTemplate:pageConfigurationCtx.data?.baseTemplate,map})
            const obj= await handleLoadedLayers(map)
    
            ocLandInsightsDictionaryCtx.set(obj)
              const selectionLayer = new GraphicsLayer({id:"selectionLayer",title:"Selection Layer"})
              let layersArray= v.map.layers.filter(layer=>layer.id==="operationalLayers")
              if(layersArray.length>0){
                let opGroupLayer = layersArray.getItemAt(0) as any
                opGroupLayer.add(selectionLayer);
              }
              selectLayerWatchLength(v,selectionLayer, selectionDataCtx.set);
              setView(v);
             setViewReady(true);
             if(!isDevelopment){
              usage_Tracking(pageConfigurationCtx.data?.['name']);
             }
              
          
          }
      
    
        }
        initView();
      },[pageConfigurationCtx.data,mapDiv,oauthChecked]);

  useEffect(()=>{
    if(Object.keys(ocLandInsightsDictionaryCtx.data).length>0 && view){
      if(window.location.search){
      AddGraphicsFromURL(view,ocLandInsightsDictionaryCtx.data?.parcels);
      }
    }else{
    }

  },[ocLandInsightsDictionaryCtx.data,view])

  useEffect(()=>{
    if(viewReady &&view && ocLandInsightsDictionaryCtx.data){
  const layerIds=ocLandInsightsDictionaryCtx.data
  addImagerytoView(view,layerIds);
  LoadWidgetOnMount(view,layerIds,pageConfigurationCtx.data);
    }
  },[viewReady,view,ocLandInsightsDictionaryCtx.data])

  return (
    [portal, oauthChecked,view,viewReady]
  )
}

export default UseMapPageLoad